/* eslint complexity: ["error", 40] */

import React, {Fragment, useMemo} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Redirect} from 'react-router-dom';
import {Carousel, Container, Fade, Col, Card, Button, Modal} from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import PendingInvitationAlerts from './pending-invitation-alerts';
import {push} from 'connected-react-router';
import Dialog from 'react-bootstrap-dialog';
import {useTranslation} from 'react-i18next';
import {FaBuilding, FaCalendarAlt, FaCalendarPlus, FaChevronRight, FaFolderPlus, FaHome, FaInfoCircle, FaList, FaSearch, FaSyncAlt, FaTrashAlt, FaTv, FaUserMd, FaUsers, FaVideo} from 'react-icons/fa';
import {
  partnerSelected,
  getPartnerFields,
  filterBookingFieldId,
  getSlots,
  purchaseVideo,
  archiveBooking,
  addVideoToPlayerArea,
  addPartnerToFavourite,
  removePartnerFromFavourite,
  showPlayerNewSubscriptionModal,
  showPlayerNewEventSubscriptionModal,
  specialEventSelected,
  getRtvVideos,
  getRtvPartnerVideos,
  addNewVideoPlaying,
  filterBookableFields,
  getPartnerEvents,
  getPartnerServices,
  deleteBooking,
  deleteServiceBooking,
  showPlayerChooseRtvChannelModal,
  rtvChannelSelected,
  removeRtvChannelFromFavourite,
  addRtvChannelToFavourite,
  getUserTags,
  getVideo,
  getVideoStreaming,
  postUsageData,
  getLiveVideos,
} from '../actions/player';
import {openVideoPlayer, preconnectVideoPlayer} from '../utils/video-player-preload';
import {showMessage} from '../actions/messages';
import Configuration from '../config';
import restaurant from '../images/ristorante.svg';
import bar from '../images/bar_icon.svg';
import accessibility from '../images/disabled_icon.svg';
import showers from '../images/shower_icon.svg';
import shop from '../images/negozio.svg';
import parking from '../images/parking_icon.svg';
import petFriendly from '../images/pets_icon.svg';
import lockerRooms from '../images/locker_room_icon.svg';
import tournaments from '../images/tournaments_icon.svg';
import picnic from '../images/picnic_area_icon.svg';
import relax from '../images/relax_icon.svg';
import camIcon from '../images/cam_icon.svg';
import replayerTvIcon from '../images/replayer_tv_icon.svg';
import buyIcon from '../images/buy_button_icon.svg'
import positionIcon from '../images/location_pointer_icon.svg';
import {subscriptionKind, subscriptionStatuses} from '../constants';
import PlayerNewSubscription from './player-new-subscription';
import PlayerNewEventSubscription from './player-new-event-subscription';
import PlayerInsufficientFunds from './player-insufficient-funds';
import playArrowWhite from '../images/play_arrow_white_48dp.png';
import replayerlogoBianco from '../images/replayer_logo_bianco_40x32px.png';
import noLogo from '../images/club_icon_grey.svg';
import PlayerChooseRtvChannel from './player-choose-rtv-channel';
import {rtvChannelIsFree, specialEventIsFree, specialEventSubscriptionStatus, subscriptionIsActive} from '../util/special-event-access';

const getSportCenterActionClassName = hasFullFirstAction => (
  `sport-center-card-actions ${hasFullFirstAction ? 'sport-center-card-actions--has-full-first' : ''} mt-auto mb-3`
);

const SPORT_LABELS = {
  tennis: 'SPORT_TENNIS',
  padel: 'SPORT_PADEL',
  pickleball: 'SPORT_PICKLEBALL'
};

const sportDisplayName = (sport, t) => {
  const normalized = String(sport || '').toLowerCase().replace(/^sport[-_\s]*/, '').replace(/^replayer[-_\s]*/, '');
  return t(SPORT_LABELS[normalized] || 'SPORT') || String(sport || normalized || '');
};

const PlayerHome = ({
  token,
  profile,
  partners,
  favouritePartners,
  bookings,
  video,
  videoStreaming,
  showPartner,
  deleteBooking,
  showCalendar,
  purchaseVideo,
  archiveBooking,
  addVideoToPlayerArea,
  goto,
  toggleFavourite,
  subscriptions,
  showReplayerTVEvent,
  permanentVideos,
  newVideosPlaying,
  addNewVideoPlaying,
  events,
  chooseReplayerTV,
  gotoReplayerTvHome,
  favouriteRtvChannels,
  toggleFavouriteRtvChannel,
  showReplayerTV,
  showReplayerTVPartnerVideo,
  refreshNewVideos,
  sendUsageData,
  gotoLiveVideos,
}) => {
  const {t, i18n} = useTranslation();
  const [clubPagePartner, setClubPagePartner] = React.useState(null);
  const hasRequestedNewVideos = React.useRef(false);
  const nextBookings = useMemo(() => bookings.filter(b => new Date(b.startDatetime) > new Date()), [bookings]);
  const nextBookingsPreview = useMemo(() => nextBookings.slice(0, 2), [nextBookings]);

  const mobileEmptyState = (variant, Icon, title, description, action, onClick) => (
    <article className={`home-mobile-empty-card home-mobile-empty-card--${variant}`}>
      <div className="home-mobile-empty-card-copy">
        <span className="home-mobile-empty-card-icon"><Icon aria-hidden="true"/></span>
        <div>
        <span className="home-mobile-empty-card-kicker">{t('PLAYER_HOME_EMPTY_STATE_KICKER')}</span>
          <h5>{title}</h5>
          <p>{description}</p>
        </div>
      </div>
      <button type="button" className="btn home-mobile-empty-card-action" onClick={onClick}>
        <Icon aria-hidden="true"/>{action}
      </button>
    </article>
  );

  React.useEffect(() => {
    if (hasRequestedNewVideos.current || video.length > 0 || videoStreaming.length > 0) {
      return;
    }

    hasRequestedNewVideos.current = true;
    refreshNewVideos();
  }, [refreshNewVideos, video.length, videoStreaming.length]);

  if (token === null) {
    return (
      <Redirect to="/login"/>
    );
  }

  let dialog = null;
  const confirmPurchase = (slots, price) => () => {
    dialog.show({
      title: t('CONFIRM_PURCHASE_TITLE'),
      body: t('CONFIRM_PURCHASE_BODY', {price}),
      actions: [
        Dialog.Action(
          t('YES'),
          () => purchaseVideo(slots),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('NO'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const deleteBookingDialog = b => () => {
    dialog.show({
      title: t('BOOKING_DELETE'),
      body: b.groupBooking ? t('BOOKING_DELETE_CONFIRM_GROUP') : t('BOOKING_DELETE_CONFIRM'),
      actions: [
        Dialog.Action(
          t('CONFIRM_DELETE'),
          () => deleteBooking(b.groupBooking || !b.multiBooking ? b.bookingId : b.users.filter(u => u.uid === profile.uid)[0].id, b.partnerId, b.sport === undefined, !b.groupBooking && b.multiBooking, partners.find(p => p.uid === b.partnerId).phoneNumber),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('DO_NOT_DELETE'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const videoInProgress = () => () => {
    dialog.show({
      title: t('VIDEO_IN_PROGRESS'),
      body: t('VIDEO_IN_PROGRESS_INFO'),
      actions: [
        Dialog.Action(
          t('CLOSE_BUTTON'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const getPurchaseStatusText = b => {
    if (b.videoPurchasable && !b.videoBought && !b.videoReady) {
      return t('VIDEO_STATUS_PURCHASABLE', {price: b.videoPrice});
    }

    if (b.videoBought && !b.videoReady) {
      return t('VIDEO_STATUS_PROCESSING');
    }

    if (b.videoBought && b.videoReady) {
      return t('VIDEO_STATUS_DOWNLOADABLE');
    }

    return '';
  };

  const getPartnerPublicSlug = partner => partner.publicSlug || partner.public_slug || null;

  const closeClubPageModal = () => setClubPagePartner(null);
  const openPartnerShop = partner => () => {
    const slug = getPartnerPublicSlug(partner);
    if (slug) {
      window.location.href = `/shop/${slug}`;
    }
  };

  const getSubscriptionStatus = (partner, channel) => {
    if (subscriptions) {
      const sub = subscriptions.subscriptions.find(s => s.partner === partner.uid && s.rtv_channel_id === channel.id && subscriptionIsActive(s));
      if (sub) {
        return {status: subscriptionStatuses.valid};
      }

      const unlimitedSubscription = subscriptions.subscriptions.find(s => subscriptionIsActive(s) && s.kind === subscriptionKind.rtvUnlimited);
      if (unlimitedSubscription) {
        return {status: subscriptionStatuses.unlimited};
      }

      const expired = subscriptions.subscriptions.find(s => s.partner === partner.uid && s.rtv_channel_id === channel.id && new Date(s.expiry) < new Date());
      if (expired) {
        return {status: subscriptionStatuses.expired, subscriptionId: expired.id};
      }

      return {status: subscriptionStatuses.noSubscription};
    }

    return {status: subscriptionStatuses.noSubscription};
  };

  const getSubscriptionStatusEvent = event => specialEventSubscriptionStatus(subscriptions, event);

  const handleFavouriteRtvChannelKeyDown = (event, partner, channel) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    const openChannel = channel.type === 0 ?
      showReplayerTV(partner, channel, getSubscriptionStatus(partner, channel)) :
      showReplayerTVPartnerVideo(partner, channel, getSubscriptionStatus(partner, channel));
    openChannel(event);
  };

  const isInAreaVideo = slotId => {
    if (permanentVideos.find(v => v.slotId === slotId)) {
      return true;
    }

    return false;
  };

  const getPartnerLogo = partnerId => {
    const partner = partners.find(p => p.uid === partnerId);
    if (partner && partner.storeImage && partner.storeImage.length > 0) {
      return `${Configuration.apiEndPoint}/images/${partnerId}?load=${partner.storeImage[0]}`;
    }

    return noLogo;
  };

  const styleBackgroundImage = (partnerId, fieldId, fieldImage) => {
    if (partnerId && fieldImage) {
      return {backgroundImage: `url(${Configuration.apiEndPoint}/partners/fields/${fieldId}/images?load=${fieldImage})`, backgroundSize: 'cover'};
    }

    return null;
  };

  return (
    <Fragment>
      <CommonMetaTag/>
      <PendingInvitationAlerts/>
      <Fade in appear className="bg_white" style={{transition: 'opacity 0.30s linear'}}>
        <Container fluid className="presentation-container">
          <div className="page-header header-filter clear-filter dashboard_hero_rp" data-parallax="true">
            <div className="dashboard_hero_overlay_rp"/>
          </div>
          <div className="main main_raised_rp">
            <div className="section">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 ml-auto mr-auto">
                    <div className="player-home-live-header">
                      <div className="player-home-live-heading">
                        <h4 className="section_title_neg_rp">{t('WATCH_LIVE')}</h4>
                        <p>{t('WATCH_LIVE_DESC')}</p>
                      </div>
                      <div className="live-now-mobile">
                        <div className="wrapper">
                          <button type="button" className="home-skywork-action home-skywork-action--live" onClick={gotoLiveVideos}>
                            <span className="home-skywork-live-camera" aria-hidden="true">
                              <FaVideo/>
                              <span className="home-skywork-live-dot"/>
                            </span>
                            <span className="home-skywork-live-copy">
                              <strong>{t('LIVE_NOW')}</strong>
                              <small>{t('DISCOVER_LIVE_STREAMS')}</small>
                            </span>
                            <FaChevronRight className="home-skywork-live-arrow" aria-hidden="true"/>
                          </button>
                        </div>
                      </div>
                      <div className="home-replayertv-mobile-actions" aria-label={t('PLAYER_HOME_REPLAYERTV_ACTIONS_ARIA')}>
                        <Button
                          type="button"
                          className="btn home-skywork-action home-skywork-action--primary"
                          onClick={gotoReplayerTvHome}
                          style={{whiteSpace: 'normal'}}
                        >
                          <FaSearch aria-hidden="true"/>
                          {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_ACTION_FIND_VIDEO')}
                        </Button>
                        <Button
                          type="button"
                          className="btn home-skywork-action home-skywork-action--secondary"
                          onClick={goto('player-show-sport-centers?bookable=true')}
                          style={{whiteSpace: 'normal'}}
                        >
                          <FaCalendarPlus aria-hidden="true"/>
                          {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_ACTION_BOOK_FIELD')}
                        </Button>
                        <Button
                          type="button"
                          className="btn home-skywork-action home-skywork-action--open-match"
                          onClick={goto('open-matches/create')}
                          style={{whiteSpace: 'normal'}}
                        >
                          <FaUsers aria-hidden="true"/>
                          {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_ACTION_CREATE_MATCH')}
                        </Button>
                        <Button
                          type="button"
                          className="btn home-skywork-action home-skywork-action--video"
                          onClick={goto('player-open-matches')}
                          style={{whiteSpace: 'normal'}}
                        >
                          <FaList aria-hidden="true"/>
                          {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_ACTION_OPEN_MATCHES')}
                        </Button>
                      </div>
                    </div>
                    <div
                      className="card player-home-replayertv-cta home-replayertv-discovery"
                      style={{
                        background: '#fff',
                        border: '1px solid rgba(0, 73, 76, 0.10)',
                        borderLeft: '6px solid #dd004a',
                        borderRadius: 16,
                        boxShadow: '0 14px 30px rgba(0, 73, 76, 0.10)',
                        overflow: 'hidden',
                        marginTop: 24,
                        marginBottom: 28,
                        padding: '24px 26px'
                      }}
                    >
                      <div className="row align-items-center">
                        <div className="col-lg-8">
                          <div className="home-replayertv-discovery-copy" style={{display: 'flex', alignItems: 'flex-start', gap: 16}}>
                            <div
                              className="home-replayertv-discovery-icon"
                              style={{
                                alignItems: 'center',
                                background: '#dd004a',
                                borderRadius: 14,
                                boxShadow: '0 10px 22px rgba(221, 0, 74, 0.22)',
                                display: 'flex',
                                height: 58,
                                justifyContent: 'center',
                                marginTop: 2,
                                minWidth: 58
                              }}
                            >
                              <img src={replayerTvIcon} alt="ReplayerTV" style={{filter: 'brightness(0) invert(1)', height: 34, width: 34}}/>
                            </div>
                            <div className="home-replayertv-discovery-text">
                              <div
                                style={{
                                  color: '#dd004a',
                                  fontSize: 12,
                                  fontWeight: 700,
                                  letterSpacing: 1.4,
                                  marginBottom: 6,
                                  textTransform: 'uppercase'
                                }}
                              >
                                ReplayerTV
                              </div>
                              <h5 style={{color: '#00494c', fontWeight: 700, marginBottom: 8}}>
                                {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_TITLE')}
                              </h5>
                              <p style={{color: '#00494c', marginBottom: 8}}>
                                {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_DESC')}
                              </p>
                              <small style={{color: '#5f777a'}}>
                                {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_HELP')}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 home-replayertv-desktop-actions" style={{marginTop: 16}}>
                          <div className="home-replayertv-discovery-actions">
                            <Button
                              type="button"
                              className="btn home-skywork-action home-skywork-action--primary"
                              onClick={gotoReplayerTvHome}
                              style={{whiteSpace: 'normal'}}
                            >
                              <FaSearch aria-hidden="true"/>
                              {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_ACTION_FIND_VIDEO')}
                            </Button>
                            <Button
                              type="button"
                              className="btn home-skywork-action home-skywork-action--secondary"
                              onClick={goto('player-show-sport-centers?bookable=true')}
                              style={{whiteSpace: 'normal'}}
                            >
                              <FaCalendarPlus aria-hidden="true"/>
                              {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_ACTION_BOOK_FIELD')}
                            </Button>
                            <Button
                              type="button"
                              className="btn home-skywork-action home-skywork-action--open-match"
                              onClick={goto('open-matches/create')}
                              style={{whiteSpace: 'normal'}}
                            >
                              <FaUsers aria-hidden="true"/>
                              {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_ACTION_CREATE_MATCH')}
                            </Button>
                            <Button
                              type="button"
                              className="btn home-skywork-action home-skywork-action--video"
                              onClick={goto('player-open-matches')}
                              style={{whiteSpace: 'normal'}}
                            >
                              <FaList aria-hidden="true"/>
                              {t('PLAYER_HOME_REPLAYERTV_DISCOVERY_ACTION_OPEN_MATCHES')}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="player-home-new-videos">
                  <div className="row">
                    <div className="col-md-12 ml-auto mr-auto">
                      <div className="player-home-new-videos-header">
                        <h4 className="section_title_neg_rp">{t('PLAYER_HOME_NEW_VIDEOS')}</h4>
                        <div className="player-home-refresh-action">
                          <Button type="button" className="btn home-skywork-action home-skywork-action--secondary video_store_head_filter_button" onClick={refreshNewVideos}>
                            <FaSyncAlt aria-hidden="true"/>
                            {t('UPDATE_VIDEOS')}
                          </Button>
                        </div>
                      </div>
                      <p>{t('HIT_REFRESH_BUTTON')}</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                {
                    videoStreaming.map(v =>
                      (
                        <div key={v.slotId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                          <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--new skywork-video-content-card--streaming">
                            <div className= "video_card_image" style={styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage)}>
                              <div className="videoWrapper" onMouseEnter={v.playable !== false && v.token ? preconnectVideoPlayer : undefined} onTouchStart={v.playable !== false && v.token ? preconnectVideoPlayer : undefined} onClick={v.playable !== false && v.token ? () => {sendUsageData(v.partnerId, v.slotId, true); openVideoPlayer(`${Configuration.krpanoPlayerUrl}?slotId=${v.slotId}&token=${v.token}`);} : undefined}>
                                <Fragment>
                                  {v.playable !== false && v.token ? (
                                    <div className="preload h-100 justify-content-center align-items-center">
                                      <img className="play_arrow" src={playArrowWhite} alt=""/>
                                    </div>
                                  ) : null}
                                  <div className="preload h-100 justify-content-start align-items-start">
                                    <img className="logo-replayer" src={replayerlogoBianco} alt=""/>
                                  </div>
                                  <div className="preload h-100 justify-content-end align-items-start">
                                    <img className="logo-partner" src={getPartnerLogo(v.partnerId)} alt=""/>
                                  </div>
                                  <div className="preload h-100 justify-content-center align-items-end">
                                    <div className="video-description justify-content-center align-items-center">{v.description ? v.description.substring(0,60) : ""}</div>
                                  </div>
                                </Fragment>
                              </div>
                            </div>
                            <div className="card-body d-flex flex-column">
                              <div className="home-new-video-info-grid">
                                <div className="home-new-video-info-box home-new-video-info-box--name">
                                  <span className="home-new-video-info-label"><FaVideo aria-hidden="true"/>{t('PLAYER_HOME_VIDEO_NAME')}</span>
                                  <strong>{v.description || v.partnerName}</strong>
                                </div>
                                <div className="home-new-video-info-box">
                                  <span className="home-new-video-info-label"><FaCalendarAlt aria-hidden="true"/>{t('PLAYER_HOME_DATE_AND_TIME')}</span>
                                  <strong>{new Date(v.startDatetime).toLocaleDateString(i18n.language, {weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric'})}</strong>
                                  <small>{t('FROM_TO_TIME', {fromTime: new Date(v.startDatetime).toLocaleTimeString(i18n.language, {hour: '2-digit', minute: '2-digit'}), toTime: new Date(v.endDatetime).toLocaleTimeString(i18n.language, {hour: '2-digit', minute: '2-digit'})})}</small>
                                </div>
                                <div className="home-new-video-info-box">
                                  <span className="home-new-video-info-label"><FaBuilding aria-hidden="true"/>{t('PLAYER_HOME_FIELD')}</span>
                                  <strong>{v.fieldName}</strong>
                                  <small>{v.partnerName}</small>
                                </div>
                              </div>
                              <div className="text-center mt-auto">
                                <button type="button" className="btn btn_blue_rp" onClick={videoInProgress()} style={{marginBottom: 20}}>{t('VIDEO_IN_PROGRESS')}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )
                  }
                  {
                    video.map(v =>
                      (
                        isInAreaVideo(v.slotId) ?
                          null :
                          <div key={v.slotId} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                            <div className="card video_card_bg_rp skywork-video-content-card skywork-video-content-card--new">
                              <div className= "video_card_image" style={styleBackgroundImage(v.partnerId, v.fieldId, v.fieldImage)}>
                                <div className="videoWrapper" onMouseEnter={preconnectVideoPlayer} onTouchStart={preconnectVideoPlayer} onClick={() => {sendUsageData(v.partnerId, v.slotId, false); openVideoPlayer(`${Configuration.krpanoPlayerUrl}?slotId=${v.slotId}&token=${v.token}`);}}>
                                  <Fragment>
                                    <div className="preload h-100 justify-content-center align-items-center">
                                      <img className="play_arrow" src={playArrowWhite} alt=""/>
                                    </div>
                                    <div className="preload h-100 justify-content-start align-items-start">
                                      <img className="logo-replayer" src={replayerlogoBianco} alt=""/>
                                    </div>
                                    <div className="preload h-100 justify-content-end align-items-start">
                                      <img className="logo-partner" src={getPartnerLogo(v.partnerId)} alt=""/>
                                    </div>
                                    <div className="preload h-100 justify-content-center align-items-end">
                                      <div className="video-description justify-content-center align-items-center">{v.description ? v.description.substring(0,60) : ""}</div>
                                    </div>
                                  </Fragment>
                                </div>
                              </div>
                              <div className="card-body d-flex flex-column">
                                <div className="home-new-video-info-grid">
                                  <div className="home-new-video-info-box home-new-video-info-box--name">
                                    <span className="home-new-video-info-label"><FaVideo aria-hidden="true"/>{t('PLAYER_HOME_VIDEO_NAME')}</span>
                                    <strong>{v.description || v.partnerName}</strong>
                                  </div>
                                  <div className="home-new-video-info-box">
                                    <span className="home-new-video-info-label"><FaCalendarAlt aria-hidden="true"/>{t('PLAYER_HOME_DATE_AND_TIME')}</span>
                                    <strong>{new Date(v.startDatetime).toLocaleDateString(i18n.language, {weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric'})}</strong>
                                    <small>{t('FROM_TO_TIME', {fromTime: new Date(v.startDatetime).toLocaleTimeString(i18n.language, {hour: '2-digit', minute: '2-digit'}), toTime: new Date(v.endDatetime).toLocaleTimeString(i18n.language, {hour: '2-digit', minute: '2-digit'})})}</small>
                                  </div>
                                  <div className="home-new-video-info-box">
                                    <span className="home-new-video-info-label"><FaBuilding aria-hidden="true"/>{t('PLAYER_HOME_FIELD')}</span>
                                    <strong>{v.fieldName}</strong>
                                    <small>{v.partnerName}</small>
                                  </div>
                                </div>
                                {v.filesize ?
                                <div className="d-flex" style={{marginBottom: 20}}>
                                  <span className="bold_title_rp mr-2">{t('FILE_SIZE')}</span>{(Math.floor(v.filesize)/(1000000000)).toFixed(2)}GB
                                </div>
                                : null}
                                <div className="text-center mt-auto">
                                  <button type="button" className="btn home-skywork-action home-skywork-action--primary mb-2" onClick={addVideoToPlayerArea(v.slotId)}><FaFolderPlus aria-hidden="true"/>{t('PLAYER_HOME_MOVE_TO_VIDEO_AREA')}</button>
                                  <p className="card-text note_card_rp">{t('PLAYER_HOME_VIDEO_DELETE_DATE')} {new Date(v.videoExpiry).toLocaleDateString(i18n.language)}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                      )
                    )
                  }
                  <div className="col-md-12 col-lg-6 mb-sm-4 card-group home-empty-desktop-only">
                    <div className="empty_slot card video_card_bg_rp home-empty-video-desktop-card">
                      <div className="card-horizontal">
                        <div className="card_image_rp col-sm-4 pl-0 pr-0">
                          <div className="videoWrapper"/>
                        </div>
                        <div className="card-body d-flex flex-column col-sm-8">
                          <h5 className="card-title">{t('PLAYER_HOME_ADD_NEW_VIDEO_TITLE')}</h5>
                          <p>{t('PLAYER_HOME_ADD_NEW_VIDEO_DESC')}</p>
                          <div className="mt-auto">
                            <button type="button" className="btn home-skywork-action home-skywork-action--secondary" onClick={goto('player-show-sport-centers')}><FaBuilding aria-hidden="true"/>{t('SPORT_CENTERS')}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 home-empty-mobile-only">
                    {mobileEmptyState(
                      'video', FaVideo, t('PLAYER_HOME_NEW_VIDEOS'),
                      t('PLAYER_HOME_NEW_VIDEOS_DESC'),
                      t('PLAYER_HOME_FIND_VIDEO_CENTER'), goto('player-show-sport-centers')
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="section">
              <div className="container pt-5">
                <div className="row">
                  <div className="col-md-12 ml-auto mr-auto">
                    <h4 className="section_title_pos_rp">{t('PLAYER_HOME_YOUR_RESERVATIONS')}</h4>
                  </div>
                </div>
                <div className="row">
                {
                  nextBookings.length !== 0 ?
                  nextBookingsPreview.map(b =>
                  (
                    <div key={b.bookingId} className="col-md-12 col-lg-6 mb-sm-4 card-group">
                      <div className="card reservation_bg_rp">
                        <div className="card-horizontal">
                          <div className="card_image_rp col-sm-3 col-lg-4 pl-0 pr-0">
                            <div className="card_image_overlay_rp">
                              <div className="card_image_icon_overlay_rp"/>
                            </div>
                          </div>
                          <div className="card-body d-flex flex-column col-sm-9 col-lg-8">
                            <h5 className="card-title">{b.partnerName}</h5>
                            <ul className="list-unstyled">
                              <li>{b.fieldName || b.serviceName}</li>
                              <li>{new Date(b.startDatetime).toLocaleDateString(i18n.language, {weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric'})}</li>
                              <li>{t('FROM_TO_TIME', {fromTime: new Date(b.startDatetime).toLocaleTimeString(i18n.language, {hour: '2-digit', minute: '2-digit'}), toTime: new Date(b.endDatetime).toLocaleTimeString(i18n.language, {hour: '2-digit', minute: '2-digit'})})}</li>
                              <li className="font-italic">{getPurchaseStatusText(b)}</li>
                            </ul>
                            <div className="mt-auto mb-2 reservation_buttons_rp">
                              {
                                b.videoPurchasable && !b.videoBought ?
                                <button type="button" className="btn home-skywork-action home-skywork-action--video" onClick={confirmPurchase(b.slots, b.videoPrice)}><FaVideo aria-hidden="true"/>{t('PURCHASE_VIDEO_BUTTON')}</button> :
                                null
                              }
                              <button type="button" className="btn home-skywork-action home-skywork-action--danger ml-0 ml-sm-3" onClick={deleteBookingDialog(b)}><FaTrashAlt aria-hidden="true"/>{t('BOOKING_DELETE')}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>))
                    :
                    <Fragment>
                    <div className="col-md-12 col-lg-6 mb-sm-4 card-group home-empty-desktop-only">
                      <div className="card empty_slot reservation_bg_rp">
                        <div className="card-horizontal">
                          <div className="card_image_rp col-sm-3 col-lg-4 pl-0 pr-0">
                            <div className="card_image_overlay_rp">
                              <div className="card_image_icon_overlay_rp"/>
                            </div>
                          </div>
                          <div className="card-body d-flex flex-column col-sm-9 col-lg-8">
                            <h5 className="card-title">{t('PLAYER_HOME_NO_RESERVATION_TITLE')}</h5>
                            <ul className="list-unstyled">
                              <li>{t('PLAYER_HOME_NO_RESERVATION_DESC')}</li>
                            </ul>
                            <div className="mt-auto mb-2 reservation_buttons_rp">
                              <button type="button" className="btn home-skywork-action home-skywork-action--secondary" onClick={goto('player-show-sport-centers')}><FaBuilding aria-hidden="true"/>{t('SPORT_CENTERS')}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 home-empty-mobile-only">
                      {mobileEmptyState(
                        'booking', FaCalendarPlus, t('PLAYER_HOME_UPCOMING_RESERVATIONS_TITLE'),
                        t('PLAYER_HOME_UPCOMING_RESERVATIONS_DESC'),
                        t('PLAYER_HOME_BOOK_FIELD'), goto('player-show-sport-centers')
                      )}
                    </div>
                    </Fragment>
                }
                </div>
                <div>
                  <button type="button" className="btn home-skywork-action home-skywork-action--secondary" onClick={goto('player-bookings')}><FaList aria-hidden="true"/>{t('SEE_ALL')}</button>
                </div>
              </div>
            </div>
            <div className="section">
              <div className="container pt-5">
                <div className="row">
                  <div className="col-md-12 ml-auto mr-auto">
                    <h4 className="section_title_pos_rp">{t('SPECIAL_EVENTS')}</h4>
                  </div>
                </div>
                <div className="row">
                  {
                    events.map(e =>
                      (
                        <Col key={e.id} xs={12} sm={12} md={12} xl={4} lg={4}>
                        <Card style={{marginBottom: 10}}>
                          <Card.Body>
                          <div className="preload h-100 justify-content-start align-items-start" style={{marginBottom: 10}}>
                            <img className="logo-partner" style={{width:"25px"}} src={getPartnerLogo(e.uid)} alt=""/> <strong>{e.businessName}</strong>
                          </div>
                          {
                            e.imageName.length === 0 ?
                              <Fragment>
                                <div className="card event_card_bg_rp">
                                  <div className="card_image_rp">
                                    <div className="videoWrapper card_image_sportcenter_rp"/>
                                </div>
                              </div> 
                              </Fragment> :
                              <Carousel style={{marginBottom: 10}} interval={null}>
                                {
                                  e.imageName.map(i =>
                                    (
                                      <Carousel.Item key={i}>
                                        <img
                                          className="d-block w-100"
                                          src={`${Configuration.apiEndPoint}/partners/events/${e.id}/images?load=${i}`}
                                          alt={t('FIRST_SLIDE')}
                                          style={{width: '100%'}}
                                        />
                                      </Carousel.Item>
                                    )
                                  )
                                }
                              </Carousel>
                            }
                            <Card.Title style={{marginTop: 30}}>
                              {e.title}
                            </Card.Title>
                            <Card.Text>
                              {e.description}
                            </Card.Text>
                            <Card.Text>
                            <img src={positionIcon} alt=""/>{e.city}
                            </Card.Text>
                            <Card.Text>
                             {t('SPECIAL_EVENT_DATES', {start_date: new Date(e.startDatetime).toLocaleDateString(i18n.language, {year: 'numeric', month: 'numeric', day: 'numeric'}), end_date: new Date(e.endDatetime).toLocaleDateString(i18n.language, {year: 'numeric', month: 'numeric', day: 'numeric'})})}
                            </Card.Text>
                          </Card.Body>
                          {
                            e.recording ?
                              <div className="d-flex favorites_card_badge mb-3">
                                <img src={replayerTvIcon} className="favorites_card_badge_icon" alt={t('ICON_FAVORITES')}/>
                                <p>{t('SPECIAL_SUBSCRIPTION') + " \"" + e.title + "\""}</p>
                                {
                                  e.rtv ?
                                    <button type="button" className="btn btn_red_rp ml-auto" style={{margin: 'auto', maxHeight: '3.3rem'}} onClick={showReplayerTVEvent(e.rtvChannelId, partners.find(p => p.uid === e.uid), getSubscriptionStatusEvent(e), e)}><img style={{width: '3.75rem', height: 'auto'}} src={buyIcon} alt=""/></button> :
                                    null
                                }
                              </div> :
                              null
                          }
                        </Card>
                      </Col>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="bg_lightgrey_rp mt-5 pb-5">
            <div className="section">
              <div className="container pt-5">
                <div className="row">
                  <div className="col-md-12 ml-auto mr-auto">
                    <h4 className="section_title_pos_rp">{t('PLAYER_HOME_FAVORITES')}</h4>
                  </div>
                </div>
                <div className="row" style={{ marginTop: 50 }}>
                  <div className="col-md-12 ml-auto mr-auto">
                    <h5 className="section_title_pos_rp">{t('RTV_CHANNELS')}</h5>
                  </div>
                </div>
                <div className="row">
                  {partners.map(p => favouriteRtvChannels.filter(c => c.uid === p.uid).map(channel =>
                    (
                      <div key={p.uid} className="col-md-12 col-lg-6 mb-sm-4 card-group" style={{ minHeight: 200 }}>
                        <div
                          role="button"
                          tabIndex={0}
                          className={channel.type === 1 ? "card video_store_bg_rp_specialist ease_fx skywork-media-channel-card" : "card video_store_bg_rp ease_fx skywork-media-channel-card"}
                          onClick={channel.type === 0 ? showReplayerTV(p, channel, getSubscriptionStatus(p, channel)) : showReplayerTVPartnerVideo(p, channel, getSubscriptionStatus(p, channel))}
                          onKeyDown={event => handleFavouriteRtvChannelKeyDown(event, p, channel)}
                          style={{cursor: 'pointer'}}
                        >
                          <div className="card-horizontal skywork-media-channel-card-layout">
                            <div className="col-sm-3 col-lg-4 pl-0 pr-0 video_store_logo_bg_rp skywork-media-channel-logo d-flex align-items-stretch justify-content-center">
                              {
                                channel.logoNames && channel.logoNames.length > 0 ?
                                  <div className="align-self-center">
                                    <img
                                      className="img-fluid"
                                      src={`${Configuration.apiEndPoint}/partners/rtv_channels/${channel.id}/images?load=${channel.logoNames[0]}`}
                                      alt={t('LOGO')}
                                    />
                                  </div> :
                                  p.storeImage && p.storeImage.length > 0 ?
                                  <div className="align-self-center">
                                    <img
                                      className="img-fluid"
                                      src={`${Configuration.apiEndPoint}/images/${p.uid}?load=${p.storeImage[0]}`}
                                      alt={t('LOGO')}
                                    />
                                  </div> :
                                  <div className="align-self-center video_store_nologo_overlay_rp"/>
                              }
                            </div>
                            <div className="card-body skywork-media-channel-copy d-flex align-items-center col-sm-9 col-lg-8">
                              <div><span>{t('PLAYER_HOME_RTV_CHANNEL_LABEL')}</span><h5 className="card-title mb-0">{channel.name}</h5></div>
                              <FaChevronRight className="skywork-media-channel-arrow" aria-hidden="true"/>
                            </div>
                            <div className="card-body skywork-media-channel-favourite d-flex align-items-center col-sm-1 col-lg-1">
                              <div className="white_favorites_card_heart_btn_active" onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                toggleFavouriteRtvChannel(channel.id, true);
                              }}/>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  ))}
                  <div className="col-md-12 col-lg-6 mb-sm-4 card-group home-empty-desktop-only">
                    <div className="card empty_slot reservation_bg_rp">
                      <div className="card-horizontal">
                        <div className="card_image_rp col-sm-3 col-lg-4 pl-0 pr-0">
                          <div className="card_image_overlay_rp d-flex align-items-stretch justify-content-center">
                            <div className="align-self-center video_store_nologo_overlay_rp"/>
                          </div>
                        </div>
                        <div className="card-body d-flex flex-column align-items-center col-sm-9 col-lg-8">
                          <h5 className="card-title">{t('PLAYER_HOME_ADD_RTV_CHANNEL_TO_FAVORITES_TITLE')}</h5>
                          <ul className="list-unstyled">
                            <li>{t('PLAYER_HOME_ADD_RTV_CHANNEL_TO_FAVORITES_DESC')}</li>
                          </ul>
                          <div className="mt-auto mb-2">
                            <button type="button" className="btn home-skywork-action home-skywork-action--primary" onClick={gotoReplayerTvHome}><FaTv aria-hidden="true"/>{t('REPLAYER_TV')}</button>
                          </div>                      
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 home-empty-mobile-only">
                    {mobileEmptyState(
                      'rtv', FaTv, t('PLAYER_HOME_FAVORITE_RTV_TITLE'),
                      t('PLAYER_HOME_FAVORITE_RTV_DESC'),
                      t('PLAYER_HOME_DISCOVER_RTVS'), gotoReplayerTvHome
                    )}
                  </div>
                </div>
                <div className="row" style={{ marginTop: 50 }}>
                  <div className="col-md-12 ml-auto mr-auto">
                    <h5 className="section_title_pos_rp">{t('SPORT_CENTERS_AND_SPORT_SPECIALISTS')}</h5>
                  </div>
                </div>
                <div className="row">
                  {
                    favouritePartners.map(p =>
                      (
                        <div key={p.uid} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                          <div className={p.isSpecialist ? "card sportspecialist_card_bg_rp" :"card sportcenter_card_bg_rp skywork-sport-center-info-card"}>
                              {
                                p.imagesNames.length === 0 ?
                                <div className="card_image_rp">
                                  <div className="videoWrapper card_image_sportcenter_rp"/>
                                </div> :
                                  <Carousel style={{marginBottom: 10}} interval={null}>
                                    {
                                      p.imagesNames.map(i =>
                                        (
                                          <Carousel.Item key={i}>
                                            <img
                                              className="d-block w-100"
                                              src={`${Configuration.apiEndPoint}/images/${p.uid}?load=${i}`}
                                              alt={t('FIRST_SLIDE')}
                                              style={{width: '100%'}}
                                            />
                                          </Carousel.Item>
                                        )
                                      )
                                    }
                                  </Carousel>
                              }
                            <div className="card-body d-flex flex-column">
                              <div className="skywork-sport-center-name-box"><h5 className="card-title">{p.name}</h5></div>
                              <div className="favorites_card_heart_btn_active" onClick={toggleFavourite(p.uid, true)}/>
                              <ul className="list-unstyled skywork-sport-center-details-box">
                                <li className="list_location_pointer">{p.city}</li>
                                {!p.isSpecialist ?
                                <li><strong>{t('SPORTS')}:</strong> {p.sports.map(sport => sportDisplayName(sport, t)).join(', ')}</li>
                                : null}
                              </ul>
                              <div className="skywork-sport-center-description-box">{p.description || t('PLAYER_HOME_NO_DESCRIPTION_AVAILABLE')}</div>
                              <ul className="card_facilities_list_icons">
                                {
                                  p.facilities && p.facilities.parking ?
                                    <li className="card_facilities_list_icons_item"><img src={parking} alt={t('ICON_PARK')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.lockerRooms ?
                                    <li className="card_facilities_list_icons_item"><img src={lockerRooms} alt={t('ICON_LOCKER_ROOMS')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.showers ?
                                    <li className="card_facilities_list_icons_item"><img src={showers} alt={t('ICON_SHOWER')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.restaurant ?
                                    <li className="card_facilities_list_icons_item"><img src={restaurant} alt={t('ICON_RESTAURANTS')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.bar ?
                                    <li className="card_facilities_list_icons_item"><img src={bar} alt={t('ICON_BAR')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.shop ?
                                    <li className="card_facilities_list_icons_item"><img src={shop} alt={t('ICON_SHOP')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.picnic ?
                                    <li className="card_facilities_list_icons_item"><img src={picnic} alt={t('ICON_PIC_NIC')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.tournaments ?
                                    <li className="card_facilities_list_icons_item"><img src={tournaments} alt={t('ICON_TOURNAMENTS')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.petFriendly ?
                                    <li className="card_facilities_list_icons_item"><img src={petFriendly} alt={t('ICON_ANIMAL')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.accessibility ?
                                    <li className="card_facilities_list_icons_item"><img src={accessibility} alt={t('ICON_DISABLED')}/></li> :
                                    null
                                }
                                {
                                  p.facilities && p.facilities.relaxArea ?
                                    <li className="card_facilities_list_icons_item"><img src={relax} alt={t('RELAX_AREA')}/></li> :
                                    null
                                }
                              </ul>
                            </div>
                            {
                              p.recording ?
                                <Fragment>
                                  <div className="d-flex favorites_card_badge mb-3">
                                  <img src={camIcon} className="favorites_card_badge_icon" alt={t('ICON_FAVORITES')}/>
                                  <p>{t('HD_VIDEO_SERVICE')}</p>
                                  {
                                    p.rtvChannels.length > 0 ?
                                      <button type="button" className="btn btn_red_rp replayer-tv-card-action ml-auto" onClick={chooseReplayerTV(p)}>
                                        <span className="replayer-tv-card-action-icon">
                                          <img src={replayerTvIcon} alt=""/>
                                        </span>
                                        <span>ReplayerTV</span>
                                      </button>
                                    : null
                                  }
                                  </div>
                                </Fragment>
                              : null
                            }
                            <div className={getSportCenterActionClassName(getPartnerPublicSlug(p))}>
                            {
                              getPartnerPublicSlug(p) ?
                                <Button type="button" className="btn sport-center-card-action sport-center-card-action--club" onClick={() => setClubPagePartner(p)}>
                                  <FaHome aria-hidden="true"/>
                                  {t('CLUB_PAGE_TITLE')}
                                </Button> :
                                null
                            }
                            {
                              (p.bookableFields && !p.isSpecialist) || (p.bookableServices && p.isSpecialist) ?
                              <button type="button" className="btn sport-center-card-action sport-center-card-action--primary" onClick={showCalendar(p, null, true)}><FaCalendarPlus aria-hidden="true"/>{t('BOOK')}</button> :
                              null
                            }
                            {
                              (p.notBookableFields && !p.isSpecialist) || (p.notBookableServices && p.isSpecialist) ?
                              <button type="button" className="btn sport-center-card-action sport-center-card-action--secondary" onClick={showCalendar(p, null, false)}>
                                <FaCalendarAlt aria-hidden="true"/>
                                {t('CALENDAR')}</button> :
                              null
                            }
                            {
                              p.shopActive && getPartnerPublicSlug(p) ?
                              <button type="button" className="btn partner-shop-card-action sport-center-card-action--shop" onClick={openPartnerShop(p)}>
                                <span className="partner-shop-card-action-icon"><img src={shop} alt=""/></span>
                                <span>{t('PLAYER_HOME_SHOP')}</span>
                              </button> :
                              null
                            }
                            <button type="button" className="btn sport-center-card-action sport-center-card-action--detail" onClick={showPartner(p)}><FaInfoCircle aria-hidden="true"/>{t('CENTER_DETAILS')}</button>
                            </div>
                          </div>
                        </div>
                      )
                    )
                  }
                  <div className="col-md-12 col-lg-4 mb-sm-4 card-group home-empty-desktop-only">
                    <div className="empty_slot card favorites_card_bg_rp">
                      <div className="card_image_rp">
                        <div className="videoWrapper"/>
                      </div>
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title">{t('PLAYER_HOME_ADD_TO_FAVORITES_TITLE')}</h5>
                        <p>{t('PLAYER_HOME_ADD_TO_FAVORITES_DESC')}</p>
                        <div className="home-skywork-action-group mt-auto">
                          <button type="button" className="btn home-skywork-action home-skywork-action--secondary" onClick={goto('player-show-sport-centers')}><FaBuilding aria-hidden="true"/>{t('SPORT_CENTERS')}</button>
                          <button type="button" className="btn home-skywork-action home-skywork-action--secondary" onClick={goto('player-show-sport-specialists')}><FaUserMd aria-hidden="true"/>{t('SPORT_SPECIALISTS')}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 home-empty-mobile-only">
                    <div className="home-mobile-favourites-grid">
                      {mobileEmptyState(
                        'center', FaBuilding, t('PLAYER_HOME_FAVORITE_CENTERS_TITLE'),
                        '',
                        t('PLAYER_HOME_FIND_FAVORITE_CENTERS'), goto('player-show-sport-centers')
                      )}
                      {mobileEmptyState(
                        'specialist', FaUserMd, t('PLAYER_HOME_FAVORITE_SPECIALISTS_TITLE'),
                        '',
                        t('PLAYER_HOME_FIND_FAVORITE_SPECIALISTS'), goto('player-show-sport-specialists')
                      )}
                    </div>
                  </div>
                </div>                
              </div>
            </div>
          </div>
          <PlayerNewSubscription/>
          <PlayerNewEventSubscription/>
          <PlayerInsufficientFunds/>          
          <PlayerChooseRtvChannel/>
          <Modal className="modal_rp" contentClassName="bg_blue_rp" show={clubPagePartner !== null} onHide={closeClubPageModal}>
            <Modal.Header closeButton>
              <Modal.Title as="h5">{t('CLUB_PAGE_TITLE')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{t('CLUB_PAGE_DESCRIPTION')}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" className="btn btn_red_rp" onClick={() => window.location.href = `/club/${getPartnerPublicSlug(clubPagePartner)}`}>
                {t('CLUB_PAGE_OPEN')}
              </Button>
              <Button variant="secondary" className="btn btn_red_outline_rp" onClick={closeClubPageModal}>
                {t('CLOSE_BUTTON')}
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </Fade>
      <Dialog
        ref={el => {
          dialog = el;
        }}/>
    </Fragment>
  );
};

PlayerHome.propTypes = {
  token: PropTypes.string,
  partners: PropTypes.array,
  favouritePartners: PropTypes.array,
  bookings: PropTypes.array,
  video: PropTypes.array,
  showPartner: PropTypes.func.isRequired,
  deleteBooking: PropTypes.func.isRequired,
  showCalendar: PropTypes.func.isRequired,
  purchaseVideo: PropTypes.func.isRequired,
  archiveBooking: PropTypes.func.isRequired,
  addVideoToPlayerArea: PropTypes.func.isRequired,
  goto: PropTypes.func.isRequired,
  toggleFavourite: PropTypes.func.isRequired,
  subscriptions: PropTypes.object,
  showReplayerTVEvent: PropTypes.func.isRequired,
  permanentVideos: PropTypes.array,
  newVideosPlaying: PropTypes.array,
  addNewVideoPlaying: PropTypes.func.isRequired,
  events: PropTypes.array,
  chooseReplayerTV: PropTypes.func.isRequired,
  gotoReplayerTvHome: PropTypes.func.isRequired,
  favouriteRtvChannels: PropTypes.array,
  toggleFavouriteRtvChannel: PropTypes.func.isRequired,
  showReplayerTV: PropTypes.func.isRequired,
};

PlayerHome.defaultProps = {
  token: null,
  partners: [],
  favouritePartners: [],
  bookings: [],
  video: [],
  subscriptions: null,
  permanentVideos: [],
  newVideosPlaying: [],
  events: [],
  favouriteRtvChannels: []
};

const mapStateToProps = ({login: {token, profile}, message, loading, player: {partners, favouritePartners, bookings, video, videoStreaming, subscriptions, permanentVideos, newVideosPlaying, events, favouriteRtvChannels}}) => ({
  token,
  profile,
  message,
  loading,
  partners,
  favouritePartners,
  bookings,
  video,
  videoStreaming,
  subscriptions,
  permanentVideos,
  newVideosPlaying,
  events,
  favouriteRtvChannels
});

const mapDispatchToProps = dispatch => ({
  showPartner: partner => () => {
    dispatch(partnerSelected(partner));
    dispatch(getPartnerFields(partner.uid));
    dispatch(getPartnerServices(partner.uid));
    dispatch(getPartnerEvents(partner.uid));
    if (!partner.isSpecialist) dispatch(push('show-partner'));
    else dispatch(push('show-partner-specialist'));
  },
  showCalendar: (partner, fieldId = null, filterBookable = false) => () => {
    dispatch(partnerSelected(partner));
    dispatch(getPartnerFields(partner.uid));
    dispatch(getPartnerServices(partner.uid));
    dispatch(filterBookingFieldId(fieldId));
    dispatch(filterBookableFields(filterBookable));
    dispatch(getSlots(partner.uid, fieldId));
    dispatch(push(filterBookable ? '/player-booking-calendar' : '/player-calendars'));
  },
  deleteBooking: (bookingId, partnerId, isService, multiBooking, phoneNumber) => {
    if(isService) dispatch(deleteServiceBooking(bookingId, partnerId, multiBooking, phoneNumber));
    else dispatch(deleteBooking(bookingId, partnerId, multiBooking, phoneNumber));
  },
  purchaseVideo: slots => {
    dispatch(purchaseVideo(slots));
  },
  archiveBooking: bookingId => {
    dispatch(archiveBooking(bookingId));
  },
  addVideoToPlayerArea: slotId => () => {
    dispatch(addVideoToPlayerArea(slotId));
    dispatch(getUserTags());
    dispatch(push('/player-video'));
  },
  goto: (path, action = null) => e => {
    if (action) {
      dispatch(action());
    }

    dispatch(push(path));
  },
  toggleFavourite: (uid, isFavourite) => () => {
    if (isFavourite) {
      dispatch(removePartnerFromFavourite(uid));
    } else {
      dispatch(addPartnerToFavourite(uid));
    }
  },
  showReplayerTVEvent: (rtvChannelId, partner, subscriptionStatus, specialEventData) => () => {
    const rtvEventChannel = partner.rtvChannels.find(c => c.id === rtvChannelId);
    if (!rtvEventChannel) {
      dispatch(showMessage('RTV_CHANNELS', 'NO_RTV_EVENT_CHANNEL'));
      return;
    }

    dispatch(rtvChannelSelected(rtvEventChannel));
    dispatch(partnerSelected(partner));
    dispatch(specialEventSelected(specialEventData));

    if (rtvEventChannel.type === 0 && (subscriptionStatus.status === subscriptionStatuses.valid || subscriptionStatus.status === subscriptionStatuses.unlimited || specialEventIsFree(specialEventData, rtvEventChannel))) {
      dispatch(getRtvVideos(partner.uid, rtvChannelId, specialEventData.id));
      dispatch(push('/player-replayer-tv'));
      return;
    }

    if (rtvEventChannel.type === 1 && subscriptionStatus.status === subscriptionStatuses.valid) {
      dispatch(getRtvPartnerVideos(partner.uid, rtvChannelId));
      dispatch(push('/player-replayer-tv-video-partner'));
      return;
    }

    if (subscriptionStatus.status === subscriptionStatuses.canRequestEvent) {
      dispatch(showPlayerNewEventSubscriptionModal(specialEventData));
      return;
    }

    if (subscriptionStatus.status === subscriptionStatuses.scheduledEvent) {
      dispatch(showMessage('SUBSCRIPTION', 'SPECIAL_EVENT_ACCESS_SCHEDULED'));
      return;
    }

    if (subscriptionStatus.status === subscriptionStatuses.expired) {
      dispatch(showMessage('SUBSCRIPTION', 'SPECIAL_EVENT_ENDED'));
      return;
    }

    dispatch(showPlayerNewSubscriptionModal());
    return;
  },
  addNewVideoPlaying: videoId => () => {
    dispatch(addNewVideoPlaying(videoId));
  },
  chooseReplayerTV: (partner) => () => {
    dispatch(rtvChannelSelected(null));
    dispatch(partnerSelected(partner));
    dispatch(showPlayerChooseRtvChannelModal());
  },
  gotoReplayerTvHome: () => {
    dispatch(push('player-replayer-tv-home'));
  },
  toggleFavouriteRtvChannel: (rtv_channel_id, isFavourite) => {
    if (isFavourite) {
      dispatch(removeRtvChannelFromFavourite(rtv_channel_id));
    } else {
      dispatch(addRtvChannelToFavourite(rtv_channel_id));
    }
  },
  showReplayerTV: (partner, rtvChannel, subscriptionStatus) => event => {
    if (event) {
      event.preventDefault();
    }
    dispatch(partnerSelected(partner));
    dispatch(rtvChannelSelected(rtvChannel));
    const partnerPublicSlug = partner.publicSlug || partner.public_slug || null;
    if (partnerPublicSlug) {
      dispatch(push(`/club/${partnerPublicSlug}?view=tv&channel_id=${rtvChannel.id}#club-matches`));
      return;
    }

    if (subscriptionStatus.status === subscriptionStatuses.valid || subscriptionStatus.status === subscriptionStatuses.unlimited || rtvChannelIsFree(rtvChannel)) {
      dispatch(getRtvVideos(partner.uid, rtvChannel.id));
      dispatch(push('/player-replayer-tv'));
      return;
    }

    if (rtvChannel.blocked) {
      dispatch(showMessage('RTV_CHANNELS', 'RTV_CHANNEL_IS_BLOCKED'));
      return;
    }
    
    dispatch(showPlayerNewSubscriptionModal());
    return;
  },
  showReplayerTVPartnerVideo: (partner, rtvChannel, subscriptionStatus) => event => {
    if (event) {
      event.preventDefault();
    }
    dispatch(partnerSelected(partner));
    dispatch(rtvChannelSelected(rtvChannel));
    const partnerPublicSlug = partner.publicSlug || partner.public_slug || null;
    if (partnerPublicSlug) {
      dispatch(push(`/club/${partnerPublicSlug}?view=tv&channel_id=${rtvChannel.id}#club-matches`));
      return;
    }

    if (subscriptionStatus.status === subscriptionStatuses.valid || rtvChannelIsFree(rtvChannel)) {
      dispatch(getRtvPartnerVideos(partner.uid, rtvChannel.id));
      dispatch(push('/player-replayer-tv-video-partner'));
      return;
    }

    if (rtvChannel.blocked) {
      dispatch(showMessage('RTV_CHANNELS', 'RTV_CHANNEL_IS_BLOCKED'));
      return;
    }
    
    dispatch(showPlayerNewSubscriptionModal());
    return;
  },
  refreshNewVideos: () => {
    dispatch(getVideo());
    dispatch(getVideoStreaming());
  },
  sendUsageData : (partnerId, slotId, streaming) => {
    dispatch(postUsageData(1, partnerId, null, slotId, streaming, 0))
  },
  gotoLiveVideos: () => {
    dispatch(getLiveVideos());
    dispatch(push('/player-live-videos'));
  }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerHome));
